import { render, staticRenderFns } from "./InstallationItemWarrantyIndicator.vue?vue&type=template&id=4ec05ee1&scoped=true&"
import script from "./InstallationItemWarrantyIndicator.vue?vue&type=script&lang=ts&"
export * from "./InstallationItemWarrantyIndicator.vue?vue&type=script&lang=ts&"
import style0 from "./InstallationItemWarrantyIndicator.vue?vue&type=style&index=0&id=4ec05ee1&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec05ee1",
  null
  
)

export default component.exports